/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import {View} from 'react-native';
import {Validation} from '../../../../common/utils/validationSinistreAV';
import {TitleLabels} from '../../../../data/constants/Sinistres/assuranceVoyage';
import {DateToHHmmFormat, DateToddmmyyyyFormat} from '../../../../data/factory';
import {useForm} from '../../../../hooks/Sinistres/useFormAV';
import SecondaryButton from '../../../components/Button/SecondaryButton';
import {InputAutocompletion} from '../../../components/Inputs/InputAutocompletion';
import {InputDatePicker} from '../../../components/Inputs/InputDatePicker';
import {InputField} from '../../../components/Inputs/InputField';
import {InputImage} from '../../../components/Inputs/InputImage';

export const Form = (props: any) => {
  const {
    data,
    listAgence,
    onCancelForm,
    onSubmitForm,
    listContrat,
    isRedirection,
    listContratSvg,
  } = props;
  const {handleChange, handleSubmit, values, errors, showErrors, dto} = useForm(
    data,
    Validation,
    handleCancel,
    handleSave,
    listAgence,
    listContrat,
    listContratSvg,
  );

  function handleCancel() {
    onCancelForm();
  }

  function handleSave() {
    if (dto.data.dateSinistre instanceof Date) {
      dto.data.dateSinistre = DateToddmmyyyyFormat(dto.data.dateSinistre);
    }
    if (dto.data.heureAccident instanceof Date) {
      dto.data.heureAccident = DateToHHmmFormat(dto.data.heureAccident);
    }
    onSubmitForm(dto.data);
  }

  return (
    <View>
      {/** form inputs */}
      <View>
        <InputAutocompletion
          label={TitleLabels.infos.numeroContrat}
          required
          data={listContrat}
          name="numeroContrat"
          value={values.numeroContrat ? values.numeroContrat : ''}
          onChange={handleChange}
          error={errors.numeroContrat}
          showError={showErrors.numeroContrat}
          maxLength={70}
          isEditable={!isRedirection}
        />
        <InputField
          label={TitleLabels.infos.nomDeclarant}
          required
          value={values.nomDeclarant}
          name="nomDeclarant"
          onChange={handleChange}
          error={errors.nomDeclarant}
          showError={showErrors.nomDeclarant}
          maxLength={70}
          isEditable={false}
        />
        <InputField
          label={TitleLabels.infos.nomVictime}
          required
          value={values.nomVictime}
          name="nomVictime"
          onChange={handleChange}
          error={errors.nomVictime}
          showError={showErrors.nomVictime}
          maxLength={70}
          isEditable={true}
        />
        <InputField
          label={TitleLabels.infos.telephone}
          required
          name="telephone"
          type="telephone"
          value={values.telephone}
          onChange={handleChange}
          error={errors.telephone}
          showError={showErrors.telephone}
          isEditable={false}
        />
        <InputDatePicker
          label={TitleLabels.infos.dateSinistre}
          required
          value={values.dateSinistre}
          name="dateSinistre"
          onChange={handleChange}
          error={errors.dateSinistre}
          showError={showErrors.dateSinistre}
          type="date"
          todayDate={true}
        />
        {
          <InputDatePicker
            label={TitleLabels.infos.heureAccident}
            required
            name="heureAccident"
            value={values.heureAccident}
            onChange={handleChange}
            error={errors.heureAccident}
            showError={showErrors.heureAccident}
            type="time"
          />
        }
        <InputField
          label={TitleLabels.infos.lieuAccident}
          required
          name="lieuAccident"
          value={values.lieuAccident}
          onChange={handleChange}
          error={errors.lieuAccident}
          showError={showErrors.lieuAccident}
          isEditable={true}
        />
        <InputAutocompletion
          label={TitleLabels.infos.agence}
          required
          data={listAgence}
          name="agence"
          value={values.agence}
          onChange={handleChange}
          error={errors.agence}
          showError={showErrors.agence}
          isEditable={false}
        />
        <InputField
          label={TitleLabels.infos.circonstanceAccident}
          required
          type="textArea"
          value={values.circonstanceAccident}
          name="circonstanceAccident"
          onChange={handleChange}
          error={errors.circonstanceAccident}
          showError={showErrors.circonstanceAccident}
          maxLength={1000}
          isEditable={true}
        />
        <InputImage
          label={TitleLabels.infos.photo}
          required
          value={values.photo}
          name="photo"
          onChange={handleChange}
          error={errors.photo}
          showError={showErrors.photo}
          maxLength={1}
        />
        <InputImage
          label={TitleLabels.infos.pieceJointeAgence}
          value={values.pieceJointeAgence}
          name="pieceJointeAgence"
          onChange={handleChange}
          error={errors.pieceJointeAgence}
          showError={showErrors.pieceJointeAgence}
          maxLength={5}
          isFile={true}
        />
      </View>
      {/** Submit buttons */}
      <View>
        <SecondaryButton
          cancelAction={handleCancel}
          submitAction={handleSubmit}
          cancelTitle="Annuler"
          submitTitle="Demander prise en compte"
        />
      </View>
    </View>
  );
};
